import {
  Box,
  Link,
  StatusIndicator,
  Table,
} from '@cloudscape-design/components';
import InspectionStatus from 'features/travelers/components/InspectionStatus';
import PropTypes from 'prop-types';
import React from 'react';

const BASE_COLUMNS = [
  {
    id: 'id',
    header: 'Traveler',
    cell: (item) => (
      <Link href={`/travelers/${item.id}`} external>
        {`${item.id.substring(0, 8)}…`}
      </Link>
    ),
  },
  {
    id: 'projectPart',
    header: 'Project - Part',
    cell: (item) => [item.project, item.pPart].filter(Boolean).join('-') || '—',
  },
  {
    id: 'lineItem',
    header: 'Line Item',
    cell: (item) => item.lineItem || '—',
  },
  {
    id: 'inventory',
    header: 'Inventory',
    cell: (item) => (
      item.productDocId
        ? <StatusIndicator type="success">Recorded</StatusIndicator>
        : <StatusIndicator type="stopped">Not recorded</StatusIndicator>
    ),
  },
  {
    id: 'lastStep',
    header: 'Last Step',
    cell: (item) => {
      const last = item.steps?.[item.steps.length - 1];
      if (!last) return <Box color="text-status-inactive">No steps</Box>;
      return <InspectionStatus inspected={last.inspected} />;
    },
  },
  {
    id: 'createdAt',
    header: 'Created At',
    // eslint-disable-next-line no-underscore-dangle
    cell: (item) => item._createdBy?.timestamp?.toDate?.()?.toLocaleString() || '—',
  },
];

export default function TravelersTable({
  items, loading = false, pagination = null,
}) {
  return (
    <Table
      variant="embedded"
      items={items}
      loading={loading}
      columnDefinitions={BASE_COLUMNS}
      empty={<Box color="text-status-inactive">No travelers</Box>}
      pagination={pagination}
    />
  );
}

TravelersTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    project: PropTypes.string,
    pPart: PropTypes.string,
    order: PropTypes.string,
    lineItem: PropTypes.string,
    productDocId: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.shape({
      inspected: PropTypes.string,
    })),
  })).isRequired,
  loading: PropTypes.bool,
  pagination: PropTypes.node,
};
